import z from "zod";

export const toNumber = (v: unknown) => {
  if (v === "" || v == null) return NaN;
  if (typeof v === "number") return v;
  const s = String(v)
    .replace(/[\s\u00A0\u202F]/g, "")
    .replace(",", ".");
  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
};

export const toUndef = (v: unknown) => (v == null || v === "" ? undefined : v);

export const isBlank = (v: unknown) => {
  if (v == null) return true;
  return String(v).trim().length === 0;
};

export const requiredString = (msg = "Обязательное поле") =>
  z
    .any()
    .transform((v) => (v == null ? "" : String(v)))
    .refine((s) => s.trim().length > 0, msg);

// export const nullishString = () =>
//   z.preprocess((v) => (v === "" ? undefined : v), z.string().optional());
export const nullishString = () =>
  z.preprocess((v) => {
    if (v === "" || v === null || v === undefined) return undefined;
    return v;
  }, z.string().optional());

export const requiredEmail = (msg = "Неверный Email") =>
  z.preprocess(toUndef, z.string({ error: () => "Обязательное поле" }).email({ error: msg }));

// export const nullishNumber = () =>
//   z.preprocess(
//     (v) => (v === "" ? undefined : toNumber(v)),
//     z.number({ error: "Некорректное число" }).finite({ error: "Некорректное число" }).optional()
//   );
export const nullishNumber = () =>
  z.preprocess((v) => {
    // пустое значение -> undefined (чтоб поле считалось необязательным)
    if (v === "" || v === null || v === undefined) return undefined;

    // строки с числами -> число
    if (typeof v === "string") {
      const s = v.replace(/\s/g, ""); // на всякий случай уберём пробелы
      const n = Number(s);
      return Number.isFinite(n) ? n : v; // если не число — пусть упадёт на z.number()
    }

    return v;
  }, z.number().finite().optional());

export const requiredNumber = (msg = "Обязательное поле") =>
  z
    .any()
    .transform(toNumber) // null/"" -> NaN
    .refine((n) => Number.isFinite(n), msg); // => "Укажите сумму"

export const asNullIfEmpty = <T extends z.ZodTypeAny>(schema: T) =>
  z.preprocess((v) => (v === "" ? null : v), schema.nullable().optional());
